module.exports = __webpack_public_path__ + "img/bg_m.bc5db507.jpg";